import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("span", { class: "c-arxiv__init-loader-box is-one" }, null, -1 /* HOISTED */);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", { class: "c-arxiv__init-loader-box is-two" }, null, -1 /* HOISTED */);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", { class: "c-arxiv__init-loader-box is-three" }, null, -1 /* HOISTED */);
const _hoisted_4 = [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3
];
import { useEntries } from '../features/useEntries';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TheLoader',
    setup(__props) {
        const { loading } = useEntries();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["c-arxiv__init-loader", _unref(loading) && 'is-loading'])
            }, _hoisted_4, 2 /* CLASS */));
        };
    }
});
